module.exports = __webpack_public_path__ + "img/2_4_1.9b96a252.jpg";